import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Dashboard from "./dashboard/Dashboard";
import Authentication from "./Authentication/Authentication";
import Shop from "./shop/Shop";
import Home from "./homepage/Home";
import { useApi } from "./Api/ApiContext";
import { useAsync } from "react-use";
import Layout, { Main } from "./Layout";
import { Alert, Col, Row, Spinner } from "reactstrap";
import useCelebritiesStore from "./store/CelebritiesStore";
import Error404 from "./Error/Error404";
import ConfirmEmailPage from "./ConfirmEmailPage";
import AboutUs from "./AboutUs";
import Terms from "./shop/Terms";
import Faq from "./shop/Faq";
import ScrollToTop from "./ScrollToTop";
import GlobalStyle from "./GlobalStyles";
import CustomThemeProvider from "./Context/CustomThemeProvider";
import CommingSoonPage from "./CommingSoonPage";
import MaintenancePage from "./MaintenancePage";

// Ces sections restent accessibles quand la page "coming soon" est activée.
const COMMING_SOON_BYPASS_PATHS = ["/auth", "/admin"];

const App = () => {
  const { pathname } = useLocation();
  const { getCelebrities, getFeatureToggle } = useApi();
  const { celebrities, storeCelebrities } = useCelebritiesStore();
  let isCommingSoon;
  let isMaintenace;

  const {
    loading: ftLoading,
    error: ftError,
    value: featuresToggle,
  } = useAsync(() => getFeatureToggle());

  const { loading, error } = useAsync(() =>
    getCelebrities().then((res) => storeCelebrities(res))
  );

  if (loading || ftLoading) {
    return (
      <CustomThemeProvider>
        <Row className={"justify-content-center mt-5"}>
          <Col xs={2} className="mx-auto">
            <Spinner color={"danger"} />
          </Col>
        </Row>
      </CustomThemeProvider>
    );
  }

  if (!ftError && featuresToggle) {
    isCommingSoon = featuresToggle.find(
      (ft) => ft?.name === "comming_soon"
    )?.enabled;

    isMaintenace = featuresToggle.find(
      (ft) => ft?.name === "maintenance"
    )?.enabled;
  }

  const isCommingSoonBypassed = COMMING_SOON_BYPASS_PATHS.some(
    (path) => pathname === path || pathname.startsWith(`${path}/`)
  );

  if (isCommingSoon && !isCommingSoonBypassed) {
    return <CommingSoonPage />;
  }

  if (isMaintenace) {
    return <MaintenancePage />;
  }

  return (
    <CustomThemeProvider>
      <ScrollToTop />
      <GlobalStyle />
      <Routes>
        <Route
          path={"/"}
          element={<Home celebrities={celebrities} celebritiesError={error} />}
        />
        <Route path={"/about-us"} element={<AboutUs />} />
        <Route path={"/terms"} element={<Terms />} />
        <Route path={"/faq"} element={<Faq />} />
        <Route path={"/confirm-email/:token"} element={<ConfirmEmailPage />} />
        <Route
          path={"/shop/*"}
          element={
            error ? (
              <Layout>
                <Main>
                  <Alert color={"danger"}>
                    <h1 className={"fs-4"}>Une erreur est survenue.</h1>
                    <p>
                      Nos équipes sont mobilisées pour rétablir le service dans
                      les meilleurs délai.
                    </p>
                  </Alert>
                </Main>
              </Layout>
            ) : (
              <Shop celebrities={celebrities} />
            )
          }
        />

        <Route path={"/admin/*"} element={<Dashboard />} />
        <Route path={"/auth/*"} element={<Authentication backPath={""} />} />
        <Route
          path={"*"}
          element={
            <>
              <Error404 />
            </>
          }
        />
      </Routes>
    </CustomThemeProvider>
  );
};

export default App;
